import { render } from "./Artboard_Poll.vue?vue&type=template&id=6ce52b82&scoped=true"
import script from "./Artboard_Poll.vue?vue&type=script&lang=js"
export * from "./Artboard_Poll.vue?vue&type=script&lang=js"

import "./Artboard_Poll.vue?vue&type=style&index=0&id=6ce52b82&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6ce52b82"

export default script